


























































































































import { namespace } from 'vuex-class';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';
import { AcgnFormTitle } from '@/components';
import AcgnPopCard from './pop-card.vue';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;

interface CardDetailType {
  link: any; // 环节
  cell: any; // 格子
  pass: any; // 审批通过
  examine: any; // 审批
  overdue: any; // 逾期
  target: any; // 目标
}

@Component({
  components: {
    AcgnFormTitle,
    AcgnPopCard,
    [Tooltip.name]: Tooltip
  }
})

/**
 * 创作方卡片
 */
export default class AcgnStatisticStaffCard extends Vue {
  public name: string = 'AcgnStatisticStaffCard';

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  // 1：管理方-员工 2：管理方-项目 3：创作方总览 4：创作方-项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @StatisticNorAction private getCreationSummary: any;
  @StatisticAction private getProuserStatistics: any;

  private pop_1 =
    { title: '总环节数', items: [{ name: '待提交', num: 0 }, { name: '已提交', num: 0 }] };
  private pop_2 =
    { title: '总件数', width: 240, items: [{ name: '审批通过', num: 0 }, { name: '审批未通过', num: 0 }] };

  private pop_11 =
    {
      title: '提交审批', width: 240, items: [{ name: '审批通过', num: 0 }, { name: '审批中', num: 0 },
      { name: '审批拒绝', num: 0 }, { name: '审批撤销', num: 0 }]
    };
  private pop_12 =
    { title: '审批通过', items: [{ name: '分镜稿', num: 0 }, { name: '勾线稿', num: 0 }, { name: '勾线稿', num: 0 }] };
  private pop_13 =
    { title: '过审率', info: '审批通过次数/提交审批次数' };

  private pop_21 =
    { title: '逾期提交率', info: '逾期提交次数/提交审批次数', items: [{ name: '逾期提交', num: 0 }] };
  private pop_22 = { title: '逾期审批率', info: '逾期审批次数/提交审批次数', items: [{ name: '逾期审批', num: 0 }] };

  private pop_31 =
    { title: '目标达成率', info: '达成数/周期数', items: [{ name: '达成数', num: 0 }, { name: '周期数', num: 0 }] };


  private cardData: CardDetailType = {  // 卡片信息
    link: {}, // 环节
    cell: {}, // 格子
    pass: {}, // 审批通过
    examine: {}, // 审批
    overdue: {}, // 逾期
    target: {} // 目标
  };
  // private isShowAllDetail: boolean = false; // 是否显示查看全部

  // 1：管理方-员工 2：管理方-项目 3：创作方总览 4：创作方-项目
  private detailRoute: any = {
    1: 'desk-statisticStaffDetail',
    2: 'desk-statisticComicNorDetail',
    3: 'desk-statisticNorDetail',
    4: 'desk-statisticNorComicDetail',
  };

  // private get taskDetailList() {
  //   if (this.isShowAllDetail) {
  //     return this.cardData.task_detail;
  //   }
  //   return this.cardData.task_detail.slice(0, 5);
  // }

  private async created() {
    this.search();
  }

  @Watch('userId')
  private userIdChange() {
    this.search();
  }

  private async search() {
    if (this.type === 1) {
      this.cardData = (await this.getCreationSummary({
        project_id: this.comicId
      })).result;
    } else {
      this.cardData = (await this.getProuserStatistics({
        project_id: this.comicId,
        user_id: this.userId
      })).result;
    }

    const link: any = this.cardData.link;
    const cell: any = this.cardData.cell;
    this.pop_1.items = [{ name: '待提交', num: link['0'] }, { name: '已提交', num: link['1'] }];
    this.pop_2.items = [{ name: '审批通过', num: cell['0'] }, { name: '审批未通过', num: cell['1'] }];

    const examine: any = this.cardData.examine;
    const pass: any = this.cardData.pass;
    this.pop_11.items =
      [{ name: '审批通过', num: examine['pass'] }, { name: '审批中', num: examine['in_approve'] },
      { name: '审批拒绝', num: examine['refuse'] }, { name: '审批撤销', num: examine['revoke'] }];
    this.pop_12.items = pass.task_detail.map((item: any) => {
      return { name: item.task_name, num: item.task_cnt };
    });

    const overdue: any = this.cardData.overdue;
    const target: any = this.cardData.target;
    this.pop_21.items = [{ name: '逾期提交', num: overdue['overdue'] }];
    this.pop_31.items = [{ name: '达成数', num: target['reach'] }, { name: '周期数', num: target['cycle'] }];
  }

  private goDetail(type: string) {
    // 目标情况只有项目才能跳转
    if (type === '4' && !this.comicId) {
      return;
    }
    const name = this.detailRoute[this.routeType];
    const params: any = { type };
    if (this.comicId) {
      params.id = this.comicId;
    }
    if (this.userId) {
      params.userid = this.userId;
    }
    this.$router.push({ name, params });
  }
}
